import { useState, useRef, useEffect, useCallback } from "react";
import CardImportFile from "../../components/cardImportFile/CardImportFile";
import ContainerWithSidebar from "../../components/UI/containerWithSidebar/ContainerWithSidebar";
import * as csv from "../../store/actions/csv";

import { H1, H2, Text, GeneralContainer } from "../../components/UI/generalLayout/Layout.styled";
import ScreenHeader from "../../components/UI/screenHeader/ScreenHeader";
import {
  ContainerInformationImport,
  FileImportTableContainer,
  InformationsDados,
  MainContainer,
  TextInformation,
} from "./FileImport.styled";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../..";
import { Alert, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { importFileColaboradorTableData, importFileDependenteTableData } from "../../constants/Objects";

import { Tabs, Tab, Box, Typography } from '@mui/material';

interface TabContentProps {
  value: number;
  index: number;
  children: React.ReactNode;
}

function TabContent({ value, index, children }: TabContentProps) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function FileImport() {
  // Mensagem caso o upload for com sucesso, ou se houver um erro no formato!
  const [statusColaborador, setStatusColaborador] = useState<Boolean>();
  const [mensageColaborador, setMensageColaborador] = useState<String>("");

  const [status, setStatusDependente] = useState<Boolean>();
  const [mensageDependente, setMensageDependente] = useState<String>("");

  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.ChangeEvent<{}>, tabNumber: number) => {
    setActiveTab(tabNumber);
  };

  const idEmpresa: any =
    useSelector((state: any) => state.login.currentCompany.id) ?? [];

  const filesElement = useRef<any>();

  // Enviar a informação para um end point
  const dispatch = useAppDispatch();

  const sendFileDependente = useCallback(async () => {
    const arquivo = filesElement.current.files;

    const retorno = await dispatch(csv.uploadCsvDependente(arquivo, idEmpresa));

    if (retorno.status === 200) {
      setStatusDependente(true);
      setMensageDependente(`O arquivo (${filesElement.current.files[0].name}) foi enviado com sucesso!`);
    } else {
      setStatusDependente(false);
      setMensageDependente(`O arquivo (${filesElement.current.files[0].name}) contém os seguintes erros:  ${retorno.response.data.errors[0]}`);
    }
  }, [dispatch]);

  const sendFileColaborador = useCallback(async () => {
    const arquivo = filesElement.current.files;

    const retorno = await dispatch(csv.uploadCsvColaborador(arquivo, idEmpresa));

    if (retorno.status === 200) {
      setStatusColaborador(true);
      setMensageColaborador(`O arquivo (${filesElement.current.files[0].name}) foi enviado com sucesso!`);
    } else {
      setStatusColaborador(false);
      setMensageColaborador(`O arquivo (${filesElement.current.files[0].name}) contém os seguintes erros:  ${retorno.response.data.errors[0]}`);
    }
  }, [dispatch]);  

  return (
    <ContainerWithSidebar>
      <GeneralContainer>
          <ScreenHeader
            screenTitle={"Importação de Colaboradores"}
            hasRightButton={false}
            rightButtonText=""
            onRightButtonClick={() => {}}
          />
          <Box sx={{ width: '100%' }}>
          
            <Tabs value={activeTab} onChange={handleTabChange} aria-label="simple tabs example">
              <Tab label="Colaborador" style={{ fontWeight: 'bold' }}/>
              <Tab label="Dependente" style={{ fontWeight: 'bold' }}/>
            </Tabs>

            <TabContent value={activeTab} index={0}>            
              {
                mensageColaborador.length > 0 && statusColaborador ? (
                  <Alert severity="success" onClose={() => setMensageColaborador("")}>{mensageColaborador}</Alert>
                ) : mensageColaborador.length > 0 ? (
                  <Alert severity="error" onClose={() => setMensageColaborador("")}>{mensageColaborador}</Alert>
                ) : ""
              }
              
              <CardImportFile onClick={sendFileColaborador} references={filesElement} />
              <ContainerInformationImport>
                <H2>Instruções para a importação do aquivo do colaborador</H2>
                <Text>
                  Se estiver com dúvida, siga o modelo abaixo para preencher corretamente
                  as colunas do arquivo de importação:
                </Text>
              </ContainerInformationImport>

              <FileImportTableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold' }}>Coluna</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold' }}>Tipo</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold' }}>Formato</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold' }}>Comentário</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold' }}>Obrigatório</TableCell>                      
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {importFileColaboradorTableData.map((data: any, index: number) => {
                      return (<TableRow
                        key={index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">{data.column}</TableCell>
                        <TableCell align="center" scope="row">{data.type}</TableCell>
                        <TableCell align="center" scope="row">{data.format}</TableCell>
                        <TableCell align="center" scope="row">{data.comment}</TableCell>
                        <TableCell align="center" scope="row">
                          {
                            data && data.required == 'S'?
                              (<div style={{ backgroundColor: 'green', borderRadius: '10px', padding: '5px', color: 'white', width: '75px' }}>Sim</div>)
                            :
                            (<div style={{ backgroundColor: 'red', borderRadius: '10px', padding: '5px', color: 'white', width: '75px' }}>Não</div>)
                          }
                        </TableCell> 
                      </TableRow>)
                    })}
                  </TableBody>
                </Table>
              </FileImportTableContainer> 
            </TabContent>
           
            <TabContent value={activeTab} index={1}>                     
              {
                mensageDependente.length > 0 && status ? (
                  <Alert severity="success" onClose={() => setMensageDependente("")}>{mensageDependente}</Alert>
                ) : mensageDependente.length > 0 ? (
                  <Alert severity="error" onClose={() => setMensageDependente("")}>{mensageDependente}</Alert>
                ) : ""
              }
              
              <CardImportFile onClick={sendFileDependente} references={filesElement} />
              <ContainerInformationImport>
                <H2>Instruções para a importação do aquivo do dependente</H2>
                <Text>
                  Se estiver com dúvida, siga o modelo abaixo para preencher corretamente
                  as colunas do arquivo de importação:
                </Text>
              </ContainerInformationImport>

              <FileImportTableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold' }}>Coluna</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold' }}>Tipo</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold' }}>Formato</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold' }}>Comentário</TableCell>
                      <TableCell align="center" style={{ fontWeight: 'bold' }}>Obrigatório</TableCell>                      
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {importFileDependenteTableData.map((data: any, index: number) => {
                      return (<TableRow
                        key={index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">{data.column}</TableCell>
                        <TableCell align="center" scope="row">{data.type}</TableCell>
                        <TableCell align="center" scope="row">{data.format}</TableCell>
                        <TableCell align="center" scope="row">{data.comment}</TableCell>
                        <TableCell align="center" scope="row">
                          {
                            data && data.required == 'S'?
                              (<div style={{ backgroundColor: 'green', borderRadius: '10px', padding: '5px', color: 'white', width: '75px' }}>Sim</div>)
                            :
                            (<div style={{ backgroundColor: 'red', borderRadius: '10px', padding: '5px', color: 'white', width: '75px' }}>Não</div>)
                          }
                        </TableCell>                        
                      </TableRow>)
                    })}
                  </TableBody>
                </Table>
              </FileImportTableContainer> 

            </TabContent>

          </Box>


        </GeneralContainer>
      </ContainerWithSidebar>
  );
}




export default FileImport;
